import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  categories: null,
}

export const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setCategory: (state, action) => {
      state.categories = action.payload
    },
  },
})

// Selectors
export const getCategoriesList = (state) => state.category.categories

// Action creators are generated for each case reducer function
export const { setCategory } = categorySlice.actions

export default categorySlice.reducer
